import Vue from "vue";

export function httpSendMobileCode(data) {
  return Vue.$axios({
    url: "/api/user/verification_code/send",
    method: "post",
    data,
  });
}

// 利用temp token发送验证码
export function httpSendCodeByTempToken(data) {
  return Vue.$axios({
    url: "/api/user/verification_code/temp_token_send",
    method: "post",
    data,
  });
}

export function httpDoRegister(data) {
  return Vue.$axios({
    url: "/api/user/public/register",
    method: "post",
    data,
  });
}

export function httpDoLogin(data) {
  return Vue.$axios({
    url: "/api/user/public/login",
    method: "post",
    data,
  });
}

export function httpResetPassword(data) {
  return Vue.$axios({
    url: "/api/user/public/passwordReset",
    method: "post",
    data,
  });
}

export function httpGetUserInfo(data) {
  return Vue.$axios({
    url: "/api/user/profile/userInfo",
    method: "get",
    data,
  });
}

/**
 * �û���Ϣ�޸�
 */
export function httpPostUserInfo(data) {
  return Vue.$axios({
    url: "/api/user/profile/userInfo",
    method: "post",
    data,
  });
}

export function httpGetInitInfo() {
  return Vue.$axios({
    url: "/api/wallet/main/init",
    method: "get",
  });
}

/**
 两部验证
 **/
export function two_factor_login(data) {
  return Vue.$axios({
    url: "/api/user/public/two_factor_login",
    method: "post",
    data,
  });
}
